import type {Mapper} from 'framework';
import type {Conversation} from '../../domain/conversation';
import type {ConversationDto} from '../dto/assistant.dto';

export class ConversationDtoToConversationMapper implements Mapper<ConversationDto, Conversation> {
  transform(dto: ConversationDto): Conversation {
    return {
      id: dto.id,
      title: dto.title,
      lastMessageAt: dto.lastMessageAt,
      createdAt: dto.createdAt,
      updatedAt: dto.updatedAt,
    };
  }
}
